import React from 'react'

function Boolean() {
    return (
        <span className='cs-data-boolean'>Boolean</span>
    )
}

export { Boolean }